import posthog from "posthog-js";
import { EventName } from "./event_names";
import { AnalyticsUser } from "./mixpanel_client";

let isInitialized = false;
let isEnabled = false;

export const initPosthogClient = () => {
    if (isInitialized) {
        return;
    }

    const apiKey = process.env.REACT_APP_POSTHOG_GENERAL_KEY || process.env.REACT_APP_POSTHOG_KEY;
    if (!apiKey) {
        return;
    }

    posthog.init(apiKey, {
        api_host: process.env.REACT_APP_POSTHOG_HOST || "https://b.vocalcentric.com",
        capture_pageview: false,
        persistence: "localStorage",
        disable_session_recording: false,
        capture_exceptions: true,
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: "*",
        },
    });
    posthog.clear_opt_in_out_capturing();
    isInitialized = true;
    isEnabled = true;
};

export const identifyPosthogUser = (user: AnalyticsUser) => {
    initPosthogClient();
    if (!isEnabled) {
        return;
    }

    const distinctId = user.uuid || user.id;
    if (!distinctId) {
        return;
    }

    posthog.identify(distinctId, {
        is_premium: user.is_premium,
        plan_type: user.plan_type,
        is_affiliate: user.is_affiliate === true,
        has_referral_code: Boolean(user.referral_code),
        ...(user.referral_code ? {referral_share_code: user.referral_code} : {}),
        created_at: user.created_at || user.createdAt,
        client_surface: "signed_in_web",
    });
};

export const trackPosthogEvent = (
    name: EventName,
    properties: Record<string, any> = {}
) => {
    initPosthogClient();
    if (!isEnabled) {
        return;
    }

    posthog.capture(name, {
        ...properties,
        client_surface: "signed_in_web",
        schema_version: 1,
    });
};

export const resetPosthogUser = () => {
    if (!isEnabled) {
        return;
    }

    posthog.reset(true);
};
